import { render, staticRenderFns } from "./StatusBox.vue?vue&type=template&id=5a73d24c&scoped=true&"
import script from "./StatusBox.vue?vue&type=script&lang=js&"
export * from "./StatusBox.vue?vue&type=script&lang=js&"
import style0 from "./StatusBox.vue?vue&type=style&index=0&id=5a73d24c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a73d24c",
  null
  
)

export default component.exports